import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-cart-drawer",
  templateUrl: "./cart-drawer.component.html",
  standalone: false,
})
export class CartDrawerComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
